// Sequential Section Animations
export function initSequentialAnimations() {
	const sections = document.querySelectorAll('.section');
	let currentSectionIndex = 0;

	// Hide all sections initially
	sections.forEach(section => {
		section.style.opacity = '0';
		section.style.transform = 'translateY(20px)';
		section.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
	});

	function animateNextSection() {
		if (currentSectionIndex >= sections.length) return;

		const currentSection = sections[currentSectionIndex];

		// Show section
		currentSection.style.opacity = '1';
		currentSection.style.transform = 'translateY(0)';

		// Special handling for header section
		if (currentSection.id === 'header') {
			// First show ASCII art
			const asciiArt = currentSection.querySelector('.ascii-art');
			if (asciiArt) {
				asciiArt.style.opacity = '1';
				asciiArt.style.transform = 'translateY(0)';
			}

			// Then handle info-block with its own prompt and content
			setTimeout(() => {
				const infoBlock = currentSection.querySelector('.info-block');
				const prompt = infoBlock
					? infoBlock.querySelector('.prompt')
					: null;
				const command = prompt
					? prompt.querySelector('.command')
					: null;
				const content = infoBlock
					? infoBlock.querySelector('.content')
					: null;

				// Show info-block container (but not its content yet)
				if (infoBlock) {
					infoBlock.style.opacity = '1';
					infoBlock.style.transform = 'translateY(0)';

					// Make sure content is still hidden
					if (content) {
						content.style.opacity = '0';
						content.style.transform = 'translateY(10px)';
					}
				}

				// Animate command typing
				if (command && content) {
					animateCommandTyping(command, () => {
						setTimeout(() => {
							content.style.opacity = '1';
							content.style.transform = 'translateY(0)';

							// Move to next section
							setTimeout(() => {
								currentSectionIndex++;
								animateNextSection();
							}, 800);
						}, 300);
					});
				}
			}, 600);
			return;
		}

		// Regular section handling
		const prompt = currentSection.querySelector('.prompt');
		const command = prompt ? prompt.querySelector('.command') : null;
		const content = currentSection.querySelector(
			'.boot-sequence, .content, .ascii-art, .skills-grid, .experience-list, .projects-grid, .education-list, .achievements-grid, .contact-info'
		);

		// Animate command typing if exists
		if (command) {
			animateCommandTyping(command, () => {
				// After command is typed, show content
				if (content) {
					setTimeout(() => {
						content.style.opacity = '1';
						content.style.transform = 'translateY(0)';

						// Animate individual items within the section
						animateContentItems(currentSection);

						// Move to next section after content is shown
						setTimeout(() => {
							currentSectionIndex++;
							// Check if this is the last section
							if (currentSectionIndex >= sections.length) {
								// All sections are done, apply initial translations and initialize interactive command line
								setTimeout(() => {
									// Apply translations if language is not Russian (default in HTML)
									const { currentLanguage, updateTranslations } = window.translationsModule;
									if (currentLanguage === 'en') {
										updateTranslations();
									}
									window.commandLineModule.initInteractiveCommandLine();
								}, 1000);
							} else {
								animateNextSection();
							}
						}, 1200);
					}, 300);
				} else {
					// No content, move to next section
					setTimeout(() => {
						currentSectionIndex++;
						// Check if this is the last section
						if (currentSectionIndex >= sections.length) {
							// All sections are done, apply initial translations and initialize interactive command line
							setTimeout(() => {
								// Apply translations if language is not Russian (default in HTML)
								const { currentLanguage, updateTranslations } = window.translationsModule;
								if (currentLanguage === 'en') {
									updateTranslations();
								}
								window.commandLineModule.initInteractiveCommandLine();
							}, 1000);
						} else {
							animateNextSection();
						}
					}, 1000);
				}
			});
		} else {
			// No command, just show content
			if (content) {
				setTimeout(() => {
					content.style.opacity = '1';
					content.style.transform = 'translateY(0)';

					// Animate individual items within the section
					animateContentItems(currentSection);
				}, 200);
			}

			setTimeout(() => {
				currentSectionIndex++;
				// Check if this is the last section
				if (currentSectionIndex >= sections.length) {
					// All sections are done, apply initial translations and initialize interactive command line
					setTimeout(() => {
						// Apply translations if language is not Russian (default in HTML)
						const { currentLanguage, updateTranslations } = window.translationsModule;
						if (currentLanguage === 'en') {
							updateTranslations();
						}
						window.commandLineModule.initInteractiveCommandLine();
					}, 1000);
				} else {
					animateNextSection();
				}
			}, 1400);
		}
	}

	// Hide all content initially
	sections.forEach(section => {
		const allContent = section.querySelectorAll(
			'.boot-sequence, .content, .ascii-art, .info-block, .skills-grid, .experience-list, .projects-grid, .education-list, .achievements-grid, .contact-info'
		);
		allContent.forEach(content => {
			content.style.opacity = '0';
			content.style.transform = 'translateY(10px)';
			content.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
		});
	});

	// Start animation sequence
	setTimeout(() => {
		animateNextSection();
	}, 1000);
}

// Animate command typing
export function animateCommandTyping(commandElement, callback) {
	const text = commandElement.textContent;
	commandElement.textContent = '';
	commandElement.style.borderRight = '2px solid var(--neon-green)';

	let i = 0;
	const timer = setInterval(() => {
		commandElement.textContent = text.slice(0, i);
		i++;

		if (i > text.length) {
			clearInterval(timer);
			commandElement.style.borderRight = 'none';
			if (callback) callback();
		}
	}, 80);
}

// Animate content items within a section
export function animateContentItems(section) {
	const items = section.querySelectorAll(
		'.skill-item, .job, .project-card, .education-item, .achievement-item, .boot-sequence .line'
	);

	items.forEach((item, index) => {
		setTimeout(() => {
			item.style.opacity = '1';
			item.style.transform = 'translateX(0)';
		}, index * 100);
	});
}

// Cursor Blink Effect
export function initCursorBlink() {
	const cursor = document.querySelector('.cursor');
	if (cursor) {
		setInterval(() => {
			cursor.style.opacity = cursor.style.opacity === '0' ? '1' : '0';
		}, 500);
	}
}